import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useContainerClick } from 'context/dash/ContainerClick'
import eventsApi from 'api/requests/events'
import Loader from 'components/_UI/Loader'
import { ProductCardsContainer } from './products.styled'
import { ContentProductCard } from './products.styled'
import ProductCard from './ProductCard'
import NotResultDashBoard from 'components/commons/NotResultDashBoard'
import paths from 'routes/paths'
import routeParams from 'theme/routeParams'

export default function EventsProductsList ({
    onDropdownAction = () => {},
    refreshKey
}) {
    const navigate = useNavigate()
    const { containerClick } = useContainerClick()
    const [loading, setLoading] = useState(true)
    const [products, setProducts] = useState([])
    const [selected, setSelected] = useState(false)

    useEffect(() => {
        if (containerClick) {
            setSelected(false)
        }
    }, [containerClick])

    async function getProducts () {
        try {
            setLoading(true)

            const response = await eventsApi.getProductsOnSale()

            setProducts(response?.data?.data)
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    // "Editar" aqui não abre formulário nenhum — leva direto pro assistente
    // do evento, na etapa de produtos, com este produto já aberto (mesmo
    // efeito de ter clicado "editar" e navegado até lá manualmente).
    function goToEventEdit (product) {
        navigate(`${paths.dashboard.events}?${routeParams.resume.editProducts}=${product.event?.slug}&${routeParams.resume.highlightProduct}=${product.id}`)
    }

    function handleDropdownAction (action, product, index) {
        if (action === 'edit') {
            goToEventEdit(product)
            return
        }

        onDropdownAction({ action, ...product })
        setSelected(index)
    }

    useEffect(() => {
        getProducts()
    }, [refreshKey])

    return (
        <>
            {
                loading ? (
                    <Loader></Loader>
                ) : products.length === 0 ? (
                    <NotResultDashBoard
                        text="Você ainda não tem produtos à venda em nenhum evento. Adicione produtos ao seu evento na etapa de produtos, durante a criação ou edição dele."
                        ilustration="stock"
                    />
                ) : (
                    <ProductCardsContainer>
                        {
                            products.map((product, index)=> (
                                <ContentProductCard key={`${product.id}-${product.event?.id}`}>
                                    <ProductCard
                                        data={product}
                                        onMoreClick={() => setSelected(index)}
                                        dropDownVisible={index === selected}
                                        visibleMoreAction
                                        showLiveStatus
                                        onProductClick={() => goToEventEdit(product)}
                                        onDropdownAction={e => handleDropdownAction(e, product, index)}
                                    />
                                </ContentProductCard>
                            ))
                        }
                    </ProductCardsContainer>
                )
            }
        </>
    )
}
